.bar {
  display: flex;
  flex: none;
  gap: var(--space-3);
  align-items: center;
  height: var(--topbar-height);
  padding: 0 var(--space-4);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

.title {
  flex: none;
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.search {
  position: relative;
  display: flex;
  flex: 0 1 280px;
  align-items: center;
  min-width: 0;
}

.searchIcon {
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  color: var(--text-faint);
  pointer-events: none;
}

.searchInput {
  width: 100%;
  padding: 6px 11px 6px 33px;
  font-family: var(--font-ui);
  font-size: var(--font-size-md);
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
}

.searchInput:disabled {
  color: var(--text-secondary);
  cursor: not-allowed;
  background: var(--bg-sunken);
}

.right {
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 0;
  margin-left: auto;
}

/*
 * Свежесть данных уступает место первой: на 1024 она обрезается, а филиал, колокольчик
 * и «Новая запись» остаются целыми. Потерять из виду филиал страшнее, чем минуту,
 * на которую устарели данные.
 */
.freshness {
  min-width: 0;
  overflow: hidden;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bell {
  width: 17px;
  height: 17px;
}

.phoneBar {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  padding: 10px var(--space-4) var(--space-2);
  background: var(--bg-workspace);
}

.phoneTitles {
  min-width: 0;
}

.phoneTitle {
  margin: 0;
  overflow: hidden;
  font-size: 17px;
  font-weight: var(--font-weight-semibold);
  line-height: 1.1;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.phoneSubtitle {
  margin: 0;
  overflow: hidden;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  white-space: nowrap;
  text-overflow: ellipsis;
}
